<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_xvii"></a>Introductory note</h2>
<p class="para">This book is about early Scotland’s contact with the Roman Empire and almost all the events described take place in the Christian era – dates are therefore <span class="small">AD</span> unless otherwise stated. Since the names of areas of North Britain and the peoples who inhabited them were either not defined or were altered considerably during this period, specific titles are used only where possible and generic terms such as Scotland and Caledonians are employed for convenience. The term ‘native’ (literally meaning a person born in an area) where used, describes an indigenous inhabitant and carries no derogatory connotation.</p>
<p class="indent-para">When describing distances, Roman units of measurement, such as miles or paces, may be employed but wherever appropriate, measurements will be converted to metric units. Surface areas of camps and forts will be quoted in acres rather than hectares owing to the continued use of the former in a substantial body of modern scholarship.</p>
<p class="para1">1 Roman mile = 1,000 paces = 5,000 Roman feet</p>
<p class="para">1 Roman mile = 0.92 Statute miles = 1.48km</p>
<p class="para">1 Roman pace = 5 Roman feet = 1.48m</p>
<p class="para">1 Roman foot = 11.65 inches = 296mm</p>
<p class="para1"><em>Abbreviations</em></p>
<p class="abb"><span class="ab">BAR</span> British Archaeological Reports</p>
<p class="abb"><span class="ab">BM</span> British Museum</p>
<p class="abb"><span class="ab">HES</span> Historic Environment Scotland</p>
<p class="abb"><span class="ab">LiDAR</span> Light Detection and Ranging</p>
<p class="abb"><span class="ab">NMS</span> National Museums Scotland</p>
<p class="abb"><span class="ab">RGK</span> Römisch-Germanische Kommission</p>
<p class="abb"><span class="ab">SAS</span> Society of Antiquaries of Scotland</p>
<div class="nobreak">
<p class="image" id="f0001"><a id="page_xviii"></a><img alt="Illustration" src="images/f0001.png"/></p>
<p class="cap">1. Map of Roman Scotland showing Roman military sites and native centres of power.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?8606b766